export const DEFAULT_ADD_SURVEY = {
  startDate: '',
  endDate: '',
  point: 0,
  name: '',
  description: '',
  questionList: [
    {
      answerList: [
        {
          content: '',
        },
        {
          content: '',
        },
      ],
      content: '',
      type: 'SIMPLE',
    },
  ],
};

export const FORMAT_DATE_NEWS = 'dd-MM-yyyy HH:mm:ss';
